'use strict';

import template from './intro_video.html';
import controller from './intro_video';

function saIntroVideo() {
  return {
    template: template,
    replace: true,
    scope: {
      video: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}

saIntroVideo.$inject = [

];

export default saIntroVideo;



// WEBPACK FOOTER //
// ./app/src/common/intro_videos/intro_video.directive.js